import React from 'react';
import { useTranslation } from 'react-i18next';
import DividerWithText from '../../../../../../../../components/DividerWithText';
import ButtonAction from '../../../../../../../../components/buttons/ButtonAction';
import {AddIcon, InfoChip} from '../../../../../../../../components/buttons/IconButtons';
import RuleForm from './RuleForm';
import CustomUserChip from "../../../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../../../Helpers/PositionModel";
import RulesTable from "./RulesTable";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const PolicyRules = ({
    item,
    rule,
    updateRuleField,
    ruleEmptyFields,
    ruleIsValid,
    ruleIsValidCalculationValue,
    ruleIsValidCalculationValueText,
    handleAddRule,
    onDragEnd,
    onDeleteRule,
}) => {
    const { t } = useTranslation();
    const isGlobal = item?.isGlobal;

    return (
        <div className='row'>
            { !isGlobal &&
                <div className={"col-12 mb-3"}>
                    <CustomUserChip
                        className={"mt-0 chip-secondary-100 w-100"}
                        name={t("you_can_add_multiple_rules_with_different_conditions")}
                        Icon={InfoChip}
                        showAvatar={true}
                        classNameIcon={"icon-color-secondary-700"}
                        classNameText={"font-color-secondary-700"}
                        iconPosition={POSITION_MODEL.LEFT}
                    />
                </div>
            }

            <div className='col-12 mb-3'>
                <DividerWithText title={t('rule_conditions')} />
            </div>

            <RuleForm
                rule={rule}
                updateRuleField={updateRuleField}
                emptyFields={ruleEmptyFields}
                isGlobal={isGlobal}
                isValid={ruleIsValid}
                isValidCalculationValue={ruleIsValidCalculationValue}
                isValidCalculationValueText={ruleIsValidCalculationValueText}
            />

            { !isGlobal &&
                <>
                    <div className='col-12 d-flex justify-content-end'>
                        <ButtonAction
                            id='btn_pr_add_rule'
                            name='add_new_rule'
                            Icon={AddIcon}
                            className='btn-secondary-600'
                            onClick={handleAddRule}
                            splitName={false}
                        />
                    </div>
                    { item.rules?.length > 0 &&
                        <div className={"border-full-shades-300 border-radius-8px mt-4"}>
                            <RulesTable
                                rules={item.rules}
                                isGlobal={isGlobal}
                                sortable={true}
                                onDragEnd={onDragEnd}
                                onDeleteRule={onDeleteRule}
                            />
                        </div>
                    }
                </>
            }
        </div>
    );
};

export default PolicyRules;
